import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const LegalComplianceData = () => {
    
    const sections = [
        { label: "Status of Compliance", value: "StatusofCompliance", items: [] },
        
    ];

    return (
        <MasterData pageTitle="Legal Compliance" sections={sections} />
    );
};

export default LegalComplianceData;